import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PendoLoadingIndicator from '../../components/loading-indicator/pendo-loading-indicator.vue.js';
import PendoEmptyState from '../../components/empty-state/pendo-empty-state.vue.js';

const defaults = {
  emptyIconColor: '#2A2C35',
  emptyIconSize: 36,
  emptyIconType: 'alert-circle',
  emptySubtext: 'Data will appear as usage occurs. Consider adjusting any applied filters.',
  emptyText: 'No Data Available',
  errorIconColor: '#DB1111',
  errorIconSize: 36,
  errorIconType: 'minus-circle',
  errorSubtext: 'Looks like something went wrong. Try reloading the page or contacting support if this issue continues.',
  errorText: 'Loading Error',
  loadingSubtext: null,
  loadingText: null,
  loadingType: 'material',
  loadingSpinnerSize: 36,
  loadingSpinnerBackground: '#FFFFFF',
  loadingSpinnerColor: undefined
};
const LOADING_STATES = {
  LOADING: 'loading',
  REJECTED: 'rejected',
  EMPTY: 'empty'
};
var script = {
  name: 'PendoStatusOverlay',
  components: {
    PendoLoadingIndicator,
    PendoEmptyState
  },
  props: {
    state: {
      type: String,
      default: null
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      LOADING_STATES
    };
  },
  computed: {
    config() {
      return _objectSpread2(_objectSpread2({}, defaults), this.options);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-status-overlay.vue2.js.map
